import { TLCLogger } from "../../../../js/lib/logger";
import { ApplicationData } from "../ApplicationData";


export const NoveListWidget = (function ( $ ) {

	var noveListSettings;
	var div = "<div></div>";

	var runNoveListWidget = function ( isbns, target ) {
		if ( typeof novSelect != 'undefined' ) {
			runNoveList( isbns, target );
		} else {
			var noveListWidgetUrl = '//imageserver.ebscohost.com/novelistselect/ns2init.js';

			var widgetScriptTag = document.createElement( "script" );
			widgetScriptTag.type = "text/javascript";
			widgetScriptTag.src = noveListWidgetUrl;

			widgetScriptTag.onload = function () {
				runNoveList( isbns, target );
			};
			widgetScriptTag.onreadystatechange = function () {
				if ( this.readyState.toLowerCase() == 'loaded' ) {
					runNoveList( isbns, target );
				}
			};

			document.getElementsByTagName( "head" )[0].appendChild( widgetScriptTag );
		}
	};

	var runNoveList = function ( isbns, target ) {
		novSelect.loadContentForISBN( isbns, noveListSettings.noveListAccount, noveListSettings.noveListPassword, function ( response ) {
			TLCLogger.log( "NoveList Response", response );
			if ( response && response.length == 0 || (response.length == 1 && response[0].content == "") ) {
				showNoContent( target );
			}
		} );
	};

	var showNoContent = function ( target ) {
		target.spin( false );
		target.html( "<p>" + ApplicationData.language.noNoveListContent + "</p>" );
	};

	return {
		append: function ( resource, target ) {
			noveListSettings = ApplicationData.locationConfiguration.getNoveListSettings();
			if ( noveListSettings.useNoveList ) {
				target.empty();
				if ( window.isIE8 == false ) {
					target.spin( "small" );
				}

				var isbns = [];
				for ( var index = 0; index < resource.standardNumbers.length; ++index ) {
					if ( resource.standardNumbers[index].type == 'Isbn' ) {
						isbns.push( resource.standardNumbers[index].data );
					}
				}

				if ( isbns.length > 0 ) {
					var isbn = null;
					$.each( isbns, function ( index, loopISBN ) {
						if ( loopISBN.length == 13 ) {
							isbn = loopISBN;
							return false;
						}
					} );

					target.removeAttr( "data-novelist-novelistselect" );
					target.attr( "data-novelist-novelistselect", isbn );
					TLCLogger.log( "ISBNS", isbns );
					runNoveListWidget( isbn, target );
				} else {
					showNoContent( target );
				}

			} else {
				target.remove();
			}

		}
	};

})( jQuery );